import { Box, Chip, Paper, Typography, useTheme } from "@mui/material";
import { useHistory } from "react-router-dom";

import { formatDecimal } from "@aclymatepackages/formatters";

import Link from "../../../atoms/mui/Link";

const FOOTPRINT_TAB_HREF = "/explorer/dashboard?view=footprint";

const MyFootprintCard = ({ totalTons }) => {
  const { palette } = useTheme();
  const history = useHistory();

  const navigateToFootprint = () => history.push(FOOTPRINT_TAB_HREF);
  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      navigateToFootprint();
    }
  };

  return (
    <Paper
      elevation={1}
      role="link"
      tabIndex={0}
      onClick={navigateToFootprint}
      onKeyDown={onKeyDown}
      aria-label="Open My Footprint"
      sx={{
        p: 2,
        borderRadius: "8px",
        flex: 1,
        minWidth: 240,
        display: "flex",
        flexDirection: "column",
        gap: 1,
        cursor: "pointer",
        transition: "box-shadow 150ms ease",
        "&:hover": { boxShadow: 4 },
        "&:focus-visible": { outline: `2px solid ${palette.primary.main}` }
      }}
    >
      <Typography variant="subtitle1" color="textPrimary">
        My footprint
      </Typography>
      <Box display="flex" alignItems="baseline" gap={1}>
        <Typography variant="h3" color="textPrimary">
          {formatDecimal(Number(totalTons) || 0)}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          tCO2e
        </Typography>
      </Box>
      <Box>
        <Chip
          label="Low confidence"
          size="small"
          sx={{
            backgroundColor: palette.backgroundGray.main,
            color: palette.text.secondary
          }}
        />
      </Box>
      <Box mt="auto" display="flex" flexDirection="column">
        <Typography variant="caption" color="textSecondary">
          Total estimated footprint
        </Typography>
        <Link href="/explorer/upgrade" color="secondary">
          <Typography variant="caption" color="secondary">
            What does this mean?
          </Typography>
        </Link>
      </Box>
    </Paper>
  );
};

export default MyFootprintCard;
